export const ADD_CATEGORIAS = 'ADD_CATEGORIAS'
export const ORDENA_STATE_A_Z ='ORDENA_STATE_A_Z'
export const ORDENA_STATE_Z_A = 'ORDENA_STATE_Z_A'